import { propsEqualityFn } from '@src/utils/object-utils/object-utils';
import { ensureHttpProtocol, ensureRelativeUrl, isExternal, isShortUrl } from '@src/utils/url-utils/url-utils';
import React, { type FC, memo, type PropsWithChildren } from 'react';
import { Link as ReactRouterLink, type LinkProps as ReactRouterLinkProps } from 'react-router';
import A from '../A/A';

export interface LinkProps {
    className?: string;
    to?: string;
    toLocationDescriptor?: ReactRouterLinkProps['to'];
    onClick?: (arg?: any) => void;
    externalLinkTarget?: string;
}

const Link: FC<PropsWithChildren<LinkProps>> = props => {
    const { onClick, to = '', children, className = '' } = props;

    function renderExternalLink() {
        const { externalLinkTarget = '_blank' } = props;

        return (
            <A target={externalLinkTarget} className={className} href={ensureHttpProtocol(to)}>
                {children}
            </A>
        );
    }

    const handleClick = e => {
        e.stopPropagation();
        if (onClick) onClick(e);
    };

    if (onClick && !to) return <span className={`link ${className}`}>{children}</span>;
    if (isExternal(to) || isShortUrl(to)) return renderExternalLink();

    function renderLinkComponent() {
        const { toLocationDescriptor } = props;

        const _to = toLocationDescriptor || ensureRelativeUrl(to);

        return (
            <ReactRouterLink onClick={handleClick} className={className} to={_to}>
                {children}
            </ReactRouterLink>
        );
    }

    return renderLinkComponent();
};

export default memo(Link, propsEqualityFn);
